import { ViewStateRecord } from '@src/suite/common/data-models/records/viewstate-record';

export enum NavigationGroupTypes {
    System = -1,
    Global = 1,
    Team = 2,
    Personal = 3,
}

export enum NavigationSectionTypes {
    System = -2,
    Default = -1,
}

export enum NavigationItemTypes {
    SYSTEM_SEARCH_GUID = '89dec730-2689-4f49-a93a-e949b46dbd42',
    SYSTEM_DEFAULT_VIEW_GUID = '24490d7c-96e2-42a4-90a8-7f1f5baf44b5',
    SYSTEM_NEW_VIEW_GUID = '6250fea1-2133-43dd-9d2a-d7bf7002fe5e',
    SYSTEM_CURRENT_VIEW_GUID = '12c21093-09dd-4b20-bb99-0241e34ac703',
    SYSTEM_SINGLE_ITEM_VIEW_GUID = '83ba92f3-37c6-4870-b047-74a7e037e94f',
}

export enum NavigationLayoutTypes {
    User = 1,
    Group = 2,
    Enterprise = 3,
    System = 4,
    Stored = 5,
}

export type NavigationItem = {
    database: string;
    path: string;
    guid: string;
    hidden: boolean;
    label: string;
    sectionId: number;
    sectionPath: string;
    groupPath: string;
    url: Array<string>;
    default: boolean;
    order: number;
    system: boolean;
    enterprise: boolean;
    viewState: ViewStateRecord;
};

export type NavigationSection = {
    id: number;
    label: string;
    order: number;
    hidden: boolean;
    enterprise: boolean;
    items: Array<NavigationItem>;
    opened: boolean;
    inEditMode: boolean;
    isNewSection: boolean;
    prevLabel: string;
    prevOpened: boolean;
    path: string;
};

export type NavigationGroup = {
    id: number;
    label: string;
    order: number;
    opened: boolean;
    items: Array<NavigationSection>;
    system: boolean;
    team: boolean;
    path: string;
    default: string;
};

export interface NavigationState {
    application: string;
    group: NavigationGroup;
    section: NavigationSection;
    item: NavigationItem;
    default: NavigationItem;

    navigation: {
        cast: NavigationGroup[];
        discover: NavigationGroup[];
        journal: NavigationGroup[];
        playbook: NavigationGroup[];
        live: NavigationGroup[];
    };
}
